import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form/immutable';

import { SEND_BRIEF_ALL } from '../../utils/static-configuration';
import Uploader from '../../components/uploader';
import { clearModal } from '../../actions/modal';
import { sendBriefAll } from './actions';

class SendBriefAllModal extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      uploaderState: 1,
      documentData: {},
    };
  }

  componentWillUnmount() {
    this.onClearModal();
  }

  onOutsideClick = event => {
    const isClickInside = this.refs.modal_content.contains(event.target);
    if (!isClickInside) {
      this.onClearModal();
    }
  };

  onClearModal = () => {
    this.props.onClearModal();
    this.setState({ uploaderState: 1, documentData: {} });
    this.props.reset();
  };

  uploadDataCallback = documentData => {
    this.setState({ documentData });
  };

  submitSendBriefAll = formData => {
    const documentData = this.state.documentData;
    documentData.approved = false;

    const message = formData.get('submitDocumentMessage');
    if (message) documentData.message = message;

    this.props.onSendBriefAll({ documentData });
  };

  updateUploaderState = newUploaderState => {
    this.setState({ uploaderState: newUploaderState });
  };

  render() {
    const { uploaderState, documentData } = this.state;
    const { handleSubmit, showModal, modalLoading } = this.props;

    return (
      <div className={showModal === SEND_BRIEF_ALL ? 'custom-modal visible' : 'custom-modal'} onClick={this.onOutsideClick}>
        <form onSubmit={handleSubmit(this.submitSendBriefAll)}>
          <div className="modal-content" ref="modal_content">
            <div className="top-text">
              <h3>Add a brief for everyone</h3>
              <p>This will be sent to all influencers on this campaign.</p>
            </div>
            <div className="modal-close large">
              <img src="/icons/close.svg" alt="close" onClick={this.onClearModal} />
            </div>
            <div className="center">
              { uploaderState === 1 &&
              <div>
                <p>
                  Wondering what to write? Find out <a href="http://blog.dyzio.co/how-to-write-a-winning-influencer-marketing-creative-brief" target="_blank"> how to write a winning creative brief</a>.
                </p>
                <div className="spacer small" />
              </div>
              }
              <table>
                <tbody>
                  <tr>
                    <td colSpan="2">
                      <Uploader
                        uploaderState={uploaderState}
                        updateUploaderState={this.updateUploaderState}
                        docType={showModal}
                        uploadDataCallback={this.uploadDataCallback}
                      />
                    </td>
                  </tr>
                  { uploaderState === 6 &&
                    <tr>
                      <td colSpan="2">
                        <h4>Message</h4>
                      </td>
                    </tr>
                  }
                  { uploaderState === 6 &&
                    <tr colSpan="2">
                      <td>
                        <Field
                          name="submitDocumentMessage"
                          label="Message"
                          component="textarea"
                          placeholder="Message about the file"
                        />
                      </td>
                    </tr>
                  }
                  { documentData.filePath && uploaderState === 6 &&
                    <tr>
                      <td colSpan="2">
                        <div className="spacer" />
                        <button className="medium rose stretch" type="submit">
                          { modalLoading ?
                            <ul className="dots">
                              <li id="dot1" />
                              <li />
                              <li id="dot2" />
                              <li />
                              <li id="dot3" />
                            </ul>
                            : <span>Send</span>
                          }
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

SendBriefAllModal.propTypes = {
  routeParams: React.PropTypes.object,
};

const mapStateToProps = state => ({
  showModal: state.modal.get('showModal'),
  modalLoading: state.modal.get('loading'),
  modalError: state.modal.get('error'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onClearModal: () => dispatch(clearModal()),
    onSendBriefAll: data => dispatch(sendBriefAll(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'DocumentUploadForm',
  })(SendBriefAllModal),
);



/** WEBPACK FOOTER **
 ** ./src/containers/send-brief-all-modal/index.js
 **/